<template>
  <div
    class="notification-item d-flex align-items-center"
    :class="{ isReaded }"
  >
    <div class="box-read">
      <img
        v-if="item.type == 'informative'"
        class="ms-2"
        src="@/assets/images/icons/icon-info.png"
        width="26"
        height="26"
      />
      <div
        v-else-if="item.type == 'automatic' && !item.icon"
        class="ms-2"
        width="26"
        height="26"
        style="border-radius: 4px"
      >
        <i style="font-size: 25px" class="icon-monitor"></i>
      </div>
      <img
        v-else
        class="ms-2"
        :src="item.icon"
        width="26"
        height="26"
        style="border-radius: 4px"
      />
    </div>
    <div class="content">
      <div
        class="notification-content pb-1"
        v-html="contentImproved ? contentImproved : item.content"
      ></div>
      <p class="time text-muted">
        {{ humanized_date }}
      </p>
    </div>
  </div>
</template>
<script>
  import moment from "moment";

  export default {
    props: ["item", "isReaded"],
    computed: {
      contentImproved() {
        if (this.item.content) {
          if (
            this.item.content.includes("Respondeu") &&
            this.item.content.includes("href")
          ) {
            let regex = /\/curso\/\d+\/aula\/\d+/g;
            let newStr = this.item.content.replace(regex, function (match) {
              return match + "?comment=true";
            });
            return newStr;
          }
        }
      },
      humanized_date() {
        // return this.item.humanize_created_at;
        return moment(this.item.created_at).fromNow();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .notification-item {
    background-color: #0b0b0b;
    transition: background 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);
    word-break: break-word;
    border-radius: 4px;
    width: 100%;

    :deep(a) {
      color: #63c98f;
    }

    &:hover {
      i {
        color: #fff;
      }
      background: #194129;
    }

    &:focus,
    &:focus-visible {
      outline: none;
      i {
        color: #fff;
      }
      background: #194129;
    }

    &.isReaded {
      &:hover {
        i {
          color: rgb(110, 110, 110);
        }
      }
      i {
        color: rgb(110, 110, 110);
      }
      .notification-content {
        :deep(p) {
          color: rgb(110, 110, 110);
          word-break: break-word;
          width: 100%;
        }
      }
    }
    .box-read {
      .circle {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #63c98f;
      }
    }

    .content {
      padding: 10px 10px 0px 10px;

      &:focus-visible {
        outline: none;
      }

      .time {
        font-size: 12px;
        line-height: 15px;
        width: 100%;
      }
    }
  }

  .notification-content {
    :deep(p) {
      white-space: initial;
      margin-bottom: 0;
      overflow-wrap: break-word;
      word-break: break-word;
      width: 100%;
    }
  }
</style>
